<template>
    <div class="mx-auto max-w-5xl px-4">
        <h1 class="mt-8 mb-4 font-semibold text-slate-600 leading-10">
            {{ page_title }}
        </h1>
    </div>
</template>

<script setup>
import {defineProps} from "vue";

const props = defineProps({
    page_title: String
})
</script>
